export default "__VITE_ASSET__BOcbdciK__"